<template>
    <div>
        <MenuPos />
        <!-- <div class="d-flex justify-space-between mb-2">
            <div class="d-flex justify-center align-center">
                <div class="img_title_takeout_admin">
                    <img src="@/assets/food-package.png">
                </div>
                <h2 class="title_takeout_admin">ซื้อกลับบ้าน</h2>
            </div>
            <v-btn color="success" height="50" width="20%" @click="$router.push('/poslist')">
                ย้อนกลับ
            </v-btn>
        </div> -->
        <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert_error"
                v-if="alert_cancel === true">ระบบได้ยกเลิกการจองคิวเรียบร้อยแล้ว...</v-alert>
        </v-slide-x-reverse-transition>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <v-card>
                <div class="pa-3">
                    <v-row>
                        <v-col cols="6" class="d-flex align-center">
                            <div>
                                <div>คิว {{ orderMain.name_pre_order }} | เวลา {{ orderMain.waiting_time }} น.
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="6" class="d-flex align-center justify-end" v-if="orderMain.status_pre_order == 0">
                            <div class=" mb-3">
                                <v-btn color="error" height="50" width="auto"
                                    @click="preOrderCancel(orderMain.id)">
                                    ยกเลิกคิวพรีออเดอร์ {{ orderMain.name_pre_order }}
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="12" v-if="data.length > 0">
                            <v-card color="blue lighten-5" class="pa-3 d-flex align-center mt-2"
                                v-for="(history_detail, list_history_key) in data" :key="list_history_key">
                                <div class="d-flex align-center">
                                    <div class="mr-2 pa-3 amount_food_order_list">{{ history_detail.amount }}</div>
                                    <div>{{ history_detail.food }}
                                        <div class="topping_food_order_list">
                                            <ul>
                                                <li v-for="(topping_name_list, key_topping) in history_detail.listTop"
                                                    :key="key_topping">
                                                    <span v-if="topping_name_list.amount"
                                                        class="amount_list_topping_order_list">{{
                    topping_name_list.amount }}</span> {{
                    topping_name_list.topingName }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="note_order_list" v-if="history_detail.description">
                                            หมายเหตุ : {{ history_detail.description }}
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center mt-4" v-else>
                            <img src="@/assets/file.png" alt="">
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center" v-if="data.length < 1">
                            <p>ไม่มีรายการอาหาร</p>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
import MenuPos from '@/components/menuadmin/MenuPos.vue'
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'preorderdetail',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {
        MenuPos
    },
    data() {
        return {
            loading_page: true,
            data: [],
            orderMain: null,
            alert_cancel: false,
        }
    },
    methods: {
        async preOrderDetailList() {
            this.loading_page = true,

                HTTP.get(`/POS/table/list_detail_pre_order/${this.$route.params.id}`, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                }).then((response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.orderList
                        this.orderMain = response.data.orderMain
                        this.loading_page = false
                    }
                }).catch((error) => {
                    this.loading_page = false
                    console.log(error)
                })
        },
        async preOrderCancel(opentable_id) {
            // this.loading_page = true
            HTTP.get(`/POS/table/cancel_pre_order/` + opentable_id, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            }).then((response) => {
                if (response.data.successful === true) {
                    this.alert_cancel = true
                    // this.loading_page = false
                    setTimeout(() => {
                        this.$router.push('/preorderlist');
                    }, 3000)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
    },
    mounted() {
        this.preOrderDetailList()
    }
}
</script>
<style scoped>
.add_delivery_poslist {
    border-bottom: 1px solid;

}

.cursor_delivery_poslist {
    cursor: pointer;
}

.buffet_list_step_three_poslist:hover::before {
    opacity: .08;
}

.colorpicker_poslist {
    width: 25px;
}

.open_table_pos_list {
    padding: 15px;
    background: #ffe1a0;
    border-radius: 20px;
}

.open_per_table_pos_list {
    padding: 15px;
    background: #806554;
    border-radius: 20px;
}

.open_on_table_pos_list {
    padding: 15px;
    background: #6c6c6c;
    border-radius: 20px;
}

.detail_table_list_pos_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.clock_notification_image {
    width: 30%;
    margin: auto;
}

.clock_notification_image>img {
    max-width: 100%;
}
</style>